module.exports = __webpack_public_path__ + "static/media/edo.dc33416f.png";